import { createApp } from 'vue'
import { createPinia } from 'pinia';
import './style.css'
import App from './App.vue'
import { createGtm } from '@gtm-support/vue-gtm';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import {library} from '@fortawesome/fontawesome-svg-core'
import { faPhone, faBars, faXmark, faRotateRight, faTimes } from '@fortawesome/free-solid-svg-icons'
import router from './router'
import { useSettingsStore } from './store'

library.add(faPhone)
library.add(faBars)
library.add(faXmark)
library.add(faRotateRight);
library.add(faTimes);
const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.use(router);


app.use(
    createGtm({
      id: "GTM-MV45TZ4F", // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
      //   queryParams: {
      //     // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
      //     gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
      //     gtm_preview: 'env-4',
      //     gtm_cookies_win: 'x',
      //   },
      //   source: 'https://customurl.com/gtm.js', // Add your own serverside GTM script
      defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
      compatibility: true, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
      nonce: "2726c7f26c", // Will add `nonce` to the script tag
      enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
      debug: true, // Whether or not display console logs debugs (optional)
      loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
      vueRouter: router, // Pass the router instance to automatically sync with router (optional)
      //   ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
      trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
    })
  );

const store = useSettingsStore()
store.initialize().then(() => {
  app.mount('#app')
}).catch(error => {
  console.error('Failed to initialize store:', error)
  app.mount('#app')
})





